import { Maybe } from 'maybe-not';
import MessageBus from '../utility/message-bus';
import { OpenAppArgs } from '../types';
import { IDict } from '../types/utility';

function translateParamsForMobile(params: OpenAppArgs): IDict<any> {
    const translatedParams: IDict<any> = params;
    translatedParams.redirectToAppStore = translatedParams.redirectToAppStore!.toString();
    return translatedParams;
}

export default function openAppSetup(messageBus: MessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('openApp')) {
        return;
    }

    return function openApp(params: OpenAppArgs): Promise<boolean> {
        if (params.redirectToAppStore === undefined) {
            params.redirectToAppStore = true;
        }
        return messageBus
            .sendRequest<boolean>(
                `executeDynamicPlatformAPI`,
                Maybe.just({
                    functionName: 'openApp',
                    args: [translateParamsForMobile(params)]
                }).map(JSON.stringify)
            )
            .then(response => Promise.resolve(response.value));
    };
}
